import { generateQuizFromText, generateQuizFromTopic, createEmptyQuiz } from "../utils/quizGenerator";

export function useQuizGeneratorLogic({
  quizInput, setQuizInput, quizType, setQuizType, quizLevel, quizCount,
  setQuizLoading, generatedQuiz, setGeneratedQuiz,
  currentTab, onInsertToBoard, activeEditor,
  setShowQuizGenerator, setSelectedTemplate,
}) {
  const handleQuizGenerate = async () => {
    if (!quizInput.trim()) {
      return;
    }

    setQuizLoading(true);
    try {
      let quizData;

      if (quizType === 'text') {
        quizData = await generateQuizFromText(quizInput, quizLevel, quizCount);
      } else {
        quizData = await generateQuizFromTopic(quizInput, quizLevel, quizCount);
      }

      setGeneratedQuiz({ ...quizData, level: quizLevel });
    } catch (error) {
      // Create empty quiz as fallback
      const fallbackQuiz = createEmptyQuiz("Generated Quiz");
      setGeneratedQuiz(fallbackQuiz);
    } finally {
      setQuizLoading(false);
    }
  };

  const handleQuizInsert = () => {
    if (currentTab > 0 && onInsertToBoard) {
      onInsertToBoard(generatedQuiz, 'quiz');
      setShowQuizGenerator(false);
      setQuizInput("");
      setQuizType('text');
      return;
    }
    if (generatedQuiz && activeEditor) {
      try {
        // Вставляем quiz как кастомный node - передаем данные как объект, а не строку
        const quizContent = {
          type: 'quizNode',
          attrs: {
            quizData: generatedQuiz // Передаем объект напрямую, не JSON.stringify
          }
        };

        activeEditor.chain().focus().insertContent(quizContent).run();
      } catch (error) {
        // Error inserting quiz
      }
    } else {
      // Cannot insert quiz - missing data or editor
    }

    // Reset states
    setShowQuizGenerator(false);
    setQuizInput("");
    setQuizType('text');
  };

  const handleQuizCancel = () => {
    setShowQuizGenerator(false);
    setQuizInput("");
    setGeneratedQuiz(null);
    setQuizType('text');
    setSelectedTemplate(null);
  };

  return { handleQuizGenerate, handleQuizInsert, handleQuizCancel };
}
